import React, { useEffect, useState } from "react";
import { Card, CardContent } from "../../components/ui/card";
import { Package, Star, MessageSquare, Mail } from "lucide-react";
import { adminApi } from "../../lib/api";

export default function DashboardPage() {
  const [analytics, setAnalytics] = useState(null);

  useEffect(() => {
    adminApi.getAnalytics().then((res) => setAnalytics(res.data)).catch(console.error);
  }, []);

  const stats = analytics
    ? [
        { label: "Products", value: analytics.total_products, icon: Package, color: "bg-sky-50 text-sky-600" },
        { label: "Testimonials", value: analytics.total_testimonials, icon: Star, color: "bg-amber-50 text-amber-600" },
        { label: "Total Messages", value: analytics.total_messages, icon: MessageSquare, color: "bg-emerald-50 text-emerald-600" },
        { label: "Unread Messages", value: analytics.unread_messages, icon: Mail, color: "bg-rose-50 text-rose-600" },
      ]
    : [];

  return (
    <div>
      <h2 className="text-2xl font-bold text-slate-900 mb-6">Overview</h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {stats.map((s) => (
          <Card key={s.label} className="border-slate-100">
            <CardContent className="p-5">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-slate-500">{s.label}</p>
                  <p className="text-3xl font-bold text-slate-900 mt-1">{s.value}</p>
                </div>
                <div className={`w-12 h-12 rounded-xl ${s.color} flex items-center justify-center`}>
                  <s.icon className="w-6 h-6" />
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
      {!analytics && (
        <div className="text-center py-16 text-slate-400">Loading analytics...</div>
      )}
    </div>
  );
}
